<template>
  <div class="theme-config-wrap">
    <div
      class="open-side-btn"
      v-show="!showSidePopup"
      @click="showSidePopup = true"
    >
      打开样式配置
    </div>
    <div class="side-popup" v-show="showSidePopup">
      <div class="close btn" @click="showSidePopup = false">X</div>
      <div class="export btn" @click="downloadThemeConfig()">导出主题配置</div>
      <div class="sec" v-for="sec in themeConfig" :key="sec.typeKey">
        <div class="sec-title">{{ sec.typeTitleName }}</div>
        <div class="sec-content">
          <div
            v-for="(item, index) in sec.cssVar"
            :key="index"
            class="sec-content-item"
          >
            <div class="color" :style="`background-color: ${item.val}`"></div>
            <div class="css-var">
              <p class="css-var-key">{{ item.name }}</p>
              <input v-model="item.val" class="css-var-input" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const cssVarArray = [
  '--section-title',
  '--input-role',
  '--input-product-search',
  '--input-paytype',
  '--input-point-card',
  '--input-bank',
  '--loading-mask',
  '--loading-bg',
  '--loading-border',
  '--global-tip-popup-title',
  '--global-tip-popup-text',
  '--global-tip-popup-btn',
  '--global-tip-popup-tip',
  '--header-coupon-entry',
  '--header-lang',
  '--footer-bg',
  '--footer',
  '--login-text',
  '--login-loginway-btn',
  '--login-restore',
  '--login-uidtoken-btn',
  '--login-uidtoken-title',
  '--login-uidtoken-back',
  '--login-uidtoken-input-title',
  '--login-uidtoken-guide-popup-title',
  '--login-uidtoken-guide-popup-otp-title',
  '--login-uidtoken-guide-popup-otp-bg',
  '--login-uidtoken-guide-popup-otp-num',
  '--login-uidtoken-guide-popup-otp-num-bg',
  '--login-uidtoken-guide-popup-otp-border',
  '--login-uidtoken-guide-popup-tip',
  '--login-uid-guide-popup-step',
  '--login-role-info',
  '--login-role-switch',
  '--login-role-info-bg',
  '--product-type-text',
  '--product-search-tip',
  '--product-order-btn',
  '--product-order-btn-active',
  '--product-coupon-border',
  '--product-coupon-text',
  '--product-coupon-bg',
  '--product-item-tag-bg',
  '--product-item-tag-border',
  '--product-item-tag-text',
  '--product-item-tag-coupon-text',
  '--product-item-tag-coupon-bg',
  '--product-item-tag-coupon-border',
  '--product-item-name',
  '--product-item-fenge-line',
  '--product-item-price',
  '--product-item-btn',
  '--product-item-prop-num',
  '--product-item-prop-popup-name',
  '--product-item-prop-popup-num',
  '--product-change-product',
  '--product-look-cart',
  '--product-tips',
  '--channel-area',
  '--channel-bg-border',
  '--channel-bg',
  '--channel-name',
  '--channel-tag-bg',
  '--channel-tag-text',
  '--channel-tag-border',
  '--channel-tip',
  '--channel-fenge-line',
  '--channel-more',
  '--channel-popup-bg',
  '--channel-popup-header-title',
  '--channel-popup-item',
  '--channel-popup-item-border',
  '--channel-popup-item-active',
  '--channel-popup-item-border-active',
  '--channel-popup-btn',
  '--channel-popup-btn-bg',
  '--submit-bg',
  '--submit-title',
  '--submit-cart',
  '--submit-discount',
  '--submit-price',
  '--submit-price-hua',
  '--submit-extra',
  '--submit-extra-border',
  '--submit-btn',
  '--submit-coupon-unchoose',
  '--submit-coupon-choose',
  '--submit-coupon-choose-border',
  '--submit-tip',
  '--coupon-popup-title',
  '--coupon-popup-type-title',
  '--coupon-popup-tip',
  '--coupon-popup-use-btn',
  '--coupon-popup-item-name',
  '--coupon-popup-item-tag',
  '--coupon-popup-item-type',
  '--coupon-popup-item-date',
  '--coupon-popup-item-line',
  '--coupon-popup-item-tip',
  '--coupon-popup-item-use-btn',
  '--coupon-popup-item-invalid-name',
  '--coupon-popup-item-invalid-tag',
  '--coupon-popup-item-invalid-type',
  '--coupon-popup-item-invalid-date',
  '--coupon-popup-item-invalid-line',
  '--coupon-popup-item-invalid-tip',
  '--coupon-popup-item-empty',
  '--coupon-popup-list-tip',
  '--cart-list-sub-bg',
  '--result-title',
  '--result-tip',
  '--result-look-more',
  '--result-order-text',
  '--result-order-bg',
  '--result-tip-text',
  '--result-error-tip',
  '--result-btn',
  '--result-discount',
  '--result-order-popup-title',
  '--result-order-popup-item-name',
  '--result-order-popup-item-num-name',
  '--result-order-popup-item-num',
  '--result-order-popup-item-total',
  '--result-order-popup-item-price',
  '--result-order-popup-item-extra',
  '--result-order-popup-item-extra-price',
  '--bank-title',
  '--bank-reselect',
  '--bank-info',
  '--bank-info-bg',
  '--bank-tip-1',
  '--bank-tip-2',
  '--bank-desc-bg',
  '--bank-table',
  '--bank-table-border',
  '--bank-btn',
  '--bank-btn-border',
  '--bank-btn-bg',
  '--bank-btn-active',
  '--bank-btn-border-active',
  '--bank-btn-bg-active',
  '--bank-link',
  '--bank-input',
  '--bank-submit-btn',
  '--vip-bg',
  '--vip-title',
  '--vip-content',
  '--vip-info',
  '--vip-level-highlight',
  '--vip-btn-text-color',
  '--vip-rule-bg',
  '--vip-table-text',
  '--vip-table-border',
  '--page-bg',
  '--event-bg',
  '--event-content',
  '--event-block',
  '--event-btn',
  '--event-title',
  '--event-tip',
  '--event-see',
  '--event-refresh',
  '--event-block-border',
  '--event-coupon-one',
  '--event-coupon-two',
  '--event-coupon-three',
  '--event-coupon-four',
  '--event-coupon-five',
  '--event-popup-tip-text'
]

const typePrefixMap = {
  '--section-title': 'sectionTitle',
  '--input': 'input',
  '--loading': 'loading',
  '--global-tip-popup': 'globalTipPopup',
  '--header': 'header',
  '--footer': 'footer',
  '--login': 'login',
  '--product': 'product',
  '--channel': 'channel',
  '--submit': 'submit',
  '--coupon-popup': 'couponPopup',
  '--cart-list': 'cartList',
  '--result': 'result',
  '--bank': 'bank',
  '--vip': 'vip',
  '--page': 'page',
  '--event': 'event',
  '--event-popup': 'eventPopup'
}

export default {
  data() {
    return {
      themeConfig: {
        sectionTitle: {
          typeTitleName: '模块标题',
          typeKey: 'sectionTitle',
          typePrefix: '--section-title',
          cssVar: []
        },
        page: {
          typeTitleName: '页面',
          typeKey: 'page',
          typePrefix: '--page',
          cssVar: []
        },
        input: {
          typeTitleName: '输入框',
          typeKey: 'input',
          typePrefix: '--input',
          cssVar: []
        },
        loading: {
          typeTitleName: 'loading',
          typeKey: 'loading',
          typePrefix: '--loading',
          cssVar: []
        },
        globalTipPopup: {
          typeTitleName: '全局提示弹窗',
          typeKey: 'globalTipPopup',
          typePrefix: '--global-tip-popup',
          cssVar: []
        },
        header: {
          typeTitleName: '顶部栏',
          typeKey: 'header',
          typePrefix: '--header',
          cssVar: []
        },
        footer: {
          typeTitleName: '底部栏',
          typeKey: 'footer',
          typePrefix: '--footer',
          cssVar: []
        },
        login: {
          typeTitleName: '登录、角色模块',
          typeKey: 'login',
          typePrefix: '--login',
          cssVar: []
        },
        product: {
          typeTitleName: '商品列表模块',
          typeKey: 'product',
          typePrefix: '--product',
          cssVar: []
        },
        channel: {
          typeTitleName: '渠道列表',
          typeKey: 'channel',
          typePrefix: '--channel',
          cssVar: []
        },
        submit: {
          typeTitleName: '提单模块',
          typeKey: 'submit',
          typePrefix: '--submit',
          cssVar: []
        },
        couponPopup: {
          typeTitleName: '优惠券弹窗',
          typeKey: 'couponPopup',
          typePrefix: '--coupon-popup',
          cssVar: []
        },
        cartList: {
          typeTitleName: '购物车弹出层',
          typeKey: 'cartList',
          typePrefix: '--cart-list',
          cssVar: []
        },
        result: {
          typeTitleName: '结果页',
          typeKey: 'result',
          typePrefix: '--result',
          cssVar: []
        },
        bank: {
          typeTitleName: '银行汇款页',
          typeKey: 'bank',
          typePrefix: '--bank',
          cssVar: []
        },
        vip: {
          typeTitleName: 'VIP积分规则页',
          typeKey: 'vip',
          typePrefix: '--vip',
          cssVar: []
        },
        event: {
          typeTitleName: '分享活动页',
          typeKey: 'event',
          typePrefix: '--event',
          cssVar: []
        },
        eventPopup: {
          typeTitleName: '分享活动弹窗',
          typeKey: 'eventPopup',
          typePrefix: '--event-popup',
          cssVar: []
        }
      },

      showSidePopup: false,

      downloadData: ''
    }
  },
  mounted() {
    let typePrefixKey = Object.keys(typePrefixMap)
    cssVarArray.forEach(item => {
      let prefixKey = typePrefixKey.find(prefix => item.indexOf(prefix) > -1)
      let config = this.themeConfig[typePrefixMap[prefixKey]]
      config.cssVar.push({
        name: item,
        val: this.getCssVarValue(item) || ''
      })
    })
  },
  watch: {
    themeConfig: {
      deep: true,
      handler(newVal) {
        let cssVarArr = []
        Object.keys(newVal).forEach(item => {
          cssVarArr = cssVarArr.concat(this.themeConfig[item].cssVar)
        })
        cssVarArr.forEach(item => {
          this.setCssVarValue(item.name, item.val)
        })
      }
    }
  },
  methods: {
    getCssVarValue(name) {
      return getComputedStyle(document.documentElement).getPropertyValue(name)
    },
    setCssVarValue(name, val) {
      document.documentElement.style.setProperty(name, val)
      document.body.style.setProperty(name, val)
    },
    downloadThemeConfig() {
      let gameCode = this.$store.getters.gameInfoConfig.gameCode
      let downloadFileName = `${gameCode}.scss`
      let cssPrefix = '.' + gameCode
      if (gameCode == 'ztmslg') {
        cssPrefix = ':root,.ztmslg'
      }
      let downloadData = `${cssPrefix} {`
      Object.keys(this.themeConfig).forEach(prefixKey => {
        downloadData = `
          ${downloadData}

          // ${this.themeConfig[prefixKey].typeTitleName}`
        this.themeConfig[prefixKey].cssVar.forEach(varItem => {
          downloadData = `${downloadData}
            ${varItem.name}: ${varItem.val};`
        })
      })
      downloadData = `
       ${downloadData}
      }`
      this.doDownload(downloadFileName, downloadData)
    },
    doDownload(filename, text) {
      let link = document.createElement('a')
      link.download = filename
      link.href = 'data:text/plain;charset=utf-8,' + encodeURIComponent(text)
      link.style.display = 'none'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    hidePopup() {
      this.showSidePopup = false
    }
  }
}
</script>


<style scoped lang="scss">
.theme-config-wrap {
  position: fixed;
  right: 0;
  bottom: 0;
  z-index: 10000;
  width: 40%;
}
.open-side-btn {
  position: absolute;
  right: 20px;
  bottom: 100px;
  padding: 5px 10px;
  border-radius: 30px;
  background: #ffca12;
  font-size: 25px;
  color: #fff;
}
.side-popup {
  overflow-y: scroll;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  .btn {
    display: inline-block;
    box-sizing: border-box;
    margin: 10px 0;
    border: 2px solid #54cc13;
    border-radius: 30px;
    width: 100%;
    height: 60px;
    cursor: pointer;
    line-height: 60px;
    text-align: center;
    font-weight: bolder;
    font-size: 30px;
    color: #54cc13;
  }
  .sec {
    margin-bottom: 20px;
    padding: 10px;
    &-title {
      font-size: 35px;
      color: #ffca12;
    }
    &-content {
      position: relative;
      padding: 6px;
      border-radius: 6px;
      width: 100%;
      &-item {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        font-size: 30px;
        color: #fff;
        .color {
          flex-shrink: 0;
          margin-right: 10px;
          border-radius: 50%;
          width: 20px;
          height: 20px;
        }
        .css-var {
          display: flex;
          flex-direction: column;
          &-key {
            text-align: left;
          }
          &-input {
            margin-top: 5px;
            font-size: 30px;
            color: #000;
          }
        }
      }
    }
  }
}
</style>